import { FieldValues, UseFormSetValue } from 'react-hook-form';

import { FormFieldUpdateObject, HasMetaProperties } from '~/core/shared/types';
import { setMetaPropertiesOnForm } from '../../../../../../../workflow/utils';

export const getHandleSetMetaPropertiesOnFormFieldUpdate =
  (
    setValue: UseFormSetValue<FieldValues>,
  ): (({
    name,
    value,
  }: FormFieldUpdateObject<Partial<HasMetaProperties>>) => void) =>
  ({ name, value }) => {
    setMetaPropertiesOnForm(name, value?.meta, setValue);
  };
